import React from 'react';
import PropTypes from 'prop-types';
import FixedSideButton from '@atoms/FixedSideButton';
import CommentCircleIcon from '../../elements/CommentCircleIcon';

const FixedFeedbackButton = ({ surveyUrl }) => (
    <FixedSideButton
        labelText="Feedback"
        bottom="14.5rem"
        bottomMobile="4rem"
        icon={<CommentCircleIcon fill="#fff" width={21} />}
        onClick={() => {
            window.open(surveyUrl, '_blank');
        }}
    />
);

FixedFeedbackButton.propTypes = {
    surveyUrl: PropTypes.string.isRequired,
};

export default FixedFeedbackButton;
